import AddLiquidityInterface from "./AddLiquidityInterface";

export default AddLiquidityInterface;
